import { Component, inject, OnInit } from '@angular/core';
import { ProfileService } from '../common/core/auth/profile.service';
import { I18NService } from '../common/core/i18n/i18n.service';
import { WelcomeDialogDataService } from './welcome-dialog-data.service';
import { DIALOG_VERSION, DIALOG_VERSION_KEY } from './dialog-version';
import { WindowRef } from '../common/core/domain/window-ref';
import { AdminuiDialogComponent } from '../common/components/dialog/adminui-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
    selector: 'adminui-welcome-dialog',
    imports: [AdminuiDialogComponent, A11yModule],
    templateUrl: './welcome-dialog.component.html'
})
export class WelcomeDialogComponent implements OnInit {
  readonly translationIndex = 'welcomeDialog';

  private profileService = inject(ProfileService);
  private i18nService = inject(I18NService);
  private welcomeDialogDataService = inject(WelcomeDialogDataService);
  private windowRef = inject(WindowRef);

  message: { [key: string]: string; } = {};
  username!: string;

  ngOnInit(): void {
    this.message = { ...this.i18nService.messages[this.translationIndex] };
    this.username = this.profileService.profile.given_name;
  }

  close(): void {
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }

  ok(): void {
    let url = "https://docs.vismasoftware.no/admin/";
    const locale = this.profileService.profile.locale;
    switch (locale) {
      case 'nb-NO': url = "https://docs.vismasoftware.no/no/admin/";
        break;
      case 'sv-SE': url = "https://docs.vismasoftware.no/sv/admin/";
        break;
    }
    this.windowRef.open(url, '_blank');
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }
}
